import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UncreditedPaymentsResponse } from './type';

const getToken = () => localStorage.getItem('token');

const getAuthorizationHeader = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : '';
};

export const uncreditedPaymentsApi = createApi({
  reducerPath: 'uncreditedPaymentsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api/worksupport`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  }),
  endpoints: (builder) => ({
    getUncreditedPayments: builder.query<UncreditedPaymentsResponse, void>({
      query: () => ({
        url: '/not-identified-payments',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetUncreditedPaymentsQuery } = uncreditedPaymentsApi;
